import React, { Component } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';

export default class NavBar extends Component {
	uncheckMenuCheckbox = () => {
		document.getElementById('menu-checkbox').checked = false;
	  };

	  scrollToTop = () => {
		scroll.scrollToTop();
		this.uncheckMenuCheckbox();
	  };

	render() {
		return(
			<nav className='top-nav-bar'>
				<div className='logo-container pull-left'>
					<div onClick={this.scrollToTop.bind(this)}>
						<img src='https://cdn.couponology.com/images/couponology-logo-transp-M.png' className='top-logo' alt='Couponology logo' />
					</div>
				</div>
				<div className='top-nav-menu-container pull-right'>
					<input type='checkbox' className='menu-icon-checkbox' id='menu-checkbox' />
					<span className='glyphicon glyphicon-menu-hamburger menu-icon' aria-hidden='true'></span>
					<ul className='top-nav-menu-list'>
						<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="home"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Home Page
							</Link>
						</li>
						<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="spotlight-stores"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Spotlight Stores
							</Link>
						</li>
						<li className='top-nav-menu-item'>
							<Link
									activeClass="active"
									to="category"
									spy={true}
									smooth={true}
									offset={-70}
									duration= {700}
									onClick={this.uncheckMenuCheckbox.bind(this)}
								>
									Category
							</Link>
						</li>
						<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="newsletter"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Newsletter
							</Link>
						</li>
						<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="video"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Video
							</Link>
						</li>
						{/*<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="social"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Social Media
							</Link>
						</li>
						<li className='top-nav-menu-item'>
							<Link
								activeClass="active"
								to="holiday"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								onClick={this.uncheckMenuCheckbox.bind(this)}
							>
								Holiday
							</Link>
						</li>*/}
					</ul>
				</div>
			</nav>
		);
	}
}